import styled from 'styled-components';
import { CardMedia } from '@material-ui/core';
const TopContainer = styled(CardMedia) `
  padding: 36px;
`;
export default TopContainer;
